const normalsList = {
  '0': '151_norm.JPG',
  '1': '152_norm.JPG',
  '2': '153_norm.JPG',
  '3': '154_norm.JPG',
  '4': '155_norm.JPG',
  '5': '156_norm.JPG',
  '6': '157_norm.JPG',
  '7': '158_norm.JPG',
  '8': '159_norm.JPG',
  '9': '160_norm.JPG',
  '10': '161_norm.JPG',
  '11': '162_norm.JPG',
  '12': '163_norm.JPG',
  '13': '164_norm.JPG',
  '14': '165_norm.JPG',
  '15': '166_norm.JPG',
  '16': '167_norm.JPG',
  '17': '168_norm.JPG',
  '18': '169_norm.JPG',
  '19': '170_norm.JPG',
  '20': '171_norm.JPG',
  '21': '172_norm.JPG',
  '22': '173_norm.JPG',
  '23': '174_norm.jpg',
  '24': '175_norm.JPG',
  '25': '176_norm.JPG',
  '26': '177_norm.JPG',
  '27': '178_norm.JPG',
  '28': '179_norm.JPG',
  '29': '180_norm.JPG',
  '30': '181_norm.JPG',
  '31': '182_norm.JPG',
  '32': '183_norm.JPG',
  '33': '184_norm.JPG',
  '34': '185_norm.JPG',
  '35': '186_norm.JPG',
  '36': '187_norm.JPG',
  '37': '188_norm.JPG',
  '38': '189_norm.JPG',
  '39': '190_norm.JPG',
  '40': '191_norm.JPG',
  '41': '192_norm.JPG',
  '42': '193_norm.JPG',
  '43': '194_norm.JPG',
  '44': '195_norm.JPG',
  '45': '196_norm.JPG',
  '46': '197_norm.JPG',
  '47': '198_norm.JPG',
  '48': '199_norm.JPG',
  '49': '200_norm.JPG',
  '50': '201_norm.jpg',
  '51': '202_norm.jpg',
  '52': '203_norm.jpg',
  '53': '204_norm.jpg',
  '54': '205_norm.jpg',
  '55': '206_norm.jpg',
  '56': '207_norm.jpg',
  '57': '208_norm.jpg',
  '58': '209_norm.jpg',
  '59': '210_norm.jpg',
  '60': '211_norm.jpg',
  '61': '212_norm.jpg',
  '62': '213_norm.jpg',
  '63': '214_norm.jpg',
  '64': '215_norm.jpg',
  '65': '216_norm.jpg',
  '66': '217_norm.jpg',
  '67': '218_norm.jpg',
  '68': '219_norm.jpg',
  '69': '220_norm.jpg',
  '70': '221_norm.jpg',
  '71': '222_norm.jpg',
  '72': '223_norm.jpg',
  '73': '224_norm.jpg',
  '74': '225_norm.jpg',
  '75': '226_norm.jpg'
};

export { normalsList };
